import { LogLevelConfiguration, type LoggerLevel } from '@/constants/logLevel';
import { useConfigStore } from '@/stores/configStore';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export type Log = {
  level: LoggerLevel;
  message: object | string;
  type: 'log' | 'warn' | 'error';
};

export function useLogger() {
  const configStore = useConfigStore();
  const { environment } = storeToRefs(configStore);

  const level = computed(() => {
    for (const value of Object.values(LogLevelConfiguration)) {
      if (value.name === environment.value) {
        return value.level;
      }
    }
    return 0;
  });

  function log(log: Log) {
    if (log.level >= level.value) {
      switch (log.type) {
        case 'log':
          console.log(log.message);
          break;
        case 'warn':
          console.warn(log.message);
          break;
        case 'error':
          console.error(log.message);
          break;
      }
    }
  }

  return { log };
}
